import { ConfirmDialog, Icon } from '@aibees/shared/components';
import { useBoolean } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { IconButton, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import { useChangeTracker } from '../../context/change-tracker';
import * as Styled from './styles';
import * as SX from './sx';
import type { HeaderNavigationProps as Props } from './types';

export const HeaderNavigation = memo(
  ({ className, drawerState, title }: Props) => {
    const state = useBoolean();
    const { isDirty, resetDirty } = useChangeTracker();

    const handleClose = () => {
      if (isDirty) {
        state.onTrue();
      } else {
        drawerState.onFalse();
      }
    };

    const handleDiscard = () => {
      resetDirty();
      state.onFalse();
      drawerState.onFalse();
    };

    const handleSaveAndExit = async () => {
      await Promise.resolve();
      resetDirty();
      state.onFalse();
      drawerState.onFalse();
    };

    return (
      <>
        <Styled.Wrapper
          className={classnames('HeaderNavigation', className)}
          sx={SX.root}
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack direction="row" alignItems="center" gap={1}>
            <Typography variant="body2" color="grey.700" fontWeight={500}>
              {title}
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center">
            <Stack direction="row" alignItems="center">
              <IconButton
                // onClick={() => handleNavigation(Navigation.PREV)}
                // disabled={itemIndex === 0}
                sx={SX.iconAccordion}
              >
                <Icon
                  name="arrow-accordion-up"
                  size={20}
                  sxx={SX.arrowsAccordion}
                />
              </IconButton>
              <IconButton
                // onClick={() => handleNavigation(Navigation.NEXT)}
                // disabled={itemIndex === companySearchItems.length - 1}
                sx={SX.iconAccordion}
              >
                <Icon
                  name="arrow-accordion"
                  size={20}
                  sxx={SX.arrowsAccordion}
                />
              </IconButton>
            </Stack>
            <IconButton onClick={handleClose}>
              <Icon name="close" size={23} sxx={SX.arrowsClose} />
            </IconButton>
          </Stack>
        </Styled.Wrapper>

        <ConfirmDialog
          state={state}
          title={
            <Stack direction="row" gap={1} alignItems="center">
              <Icon name="alert" size={24} color="primary.400" />
              <Typography variant="body2" color="grey.800" fontWeight={600}>
                Unsaved Changes
              </Typography>
            </Stack>
          }
          content={
            <Stack gap={1}>
              <Typography variant="body3" color="grey.900" fontWeight={500}>
                You’ve made some changes that haven’t been saved. If you close
                now, your edits will be lost.
              </Typography>
              <Typography variant="body3" color="grey.900" fontWeight={500}>
                Would you like to save before exiting?
              </Typography>
            </Stack>
          }
          onOk={handleSaveAndExit}
          onCancel={handleDiscard}
          okTitle="Save and Exit"
          cancelTitle="Discard Changes"
          okProps={{ variant: 'contained', color: 'primary' }}
          cancelProps={{ variant: 'text', color: 'inherit' }}
          actionsSx={SX.actions}
          headerSx={SX.header}
        />
      </>
    );
  }
);

HeaderNavigation.displayName = 'HeaderNavigation';
